export default __webpack_public_path__ + "static/528-1807ae10d66cc72176040d7cdf5f6ba9.gif";